export default __webpack_public_path__ + "static/media/who-are-we.90c9f0f1.pdf";